var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "strategy" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleUpdatePnlCommand.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c("h6", [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/enterprise/pnls/${_vm.workspaceId}/${_vm.strategyId}`,
                                expression:
                                  "`/#/enterprise/pnls/${workspaceId}/${strategyId}`",
                              },
                            ],
                            staticClass: "text-dark",
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-angle-double-left",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Back to P&Ls\n                        "),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticStyle: {
                            "font-size": "2em",
                            "font-weight": "300",
                            color: "#33475b",
                            margin: "0",
                          },
                        },
                        [_vm._v("Edit P&L template")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 text-right align-self-end" },
                      [
                        _c("SaveButton", {
                          attrs: {
                            savingState: _vm.savingState,
                            isFormSubmit: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr", {
                    staticStyle: {
                      "border-color": "#bbb",
                      margin: "20px 0 60px",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Name:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.rm.Name,
                          expression: "rm.Name",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", required: "" },
                      domProps: { value: _vm.rm.Name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.rm, "Name", $event.target.value.trim())
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Start year:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.rm.StartYear,
                          expression: "rm.StartYear",
                          modifiers: { number: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: "2023",
                        max: "2100",
                        step: "1",
                      },
                      domProps: { value: _vm.rm.StartYear },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.rm,
                            "StartYear",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Start month:")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rm.StartMonth,
                            expression: "rm.StartMonth",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.rm,
                              "StartMonth",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Current month (dynamic)"),
                        ]),
                        _vm._v(" "),
                        _vm._l(12, function (i) {
                          return _c(
                            "option",
                            { key: i, domProps: { value: i } },
                            [_vm._v(_vm._s(i))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Columns:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.rm.Columns,
                          expression: "rm.Columns",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "" },
                      domProps: { value: _vm.rm.Columns },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.rm,
                            "Columns",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }